module.exports = __webpack_public_path__ + "static/4-4c79c3b3c8407827c663049f09196e80.gif";